/**
 * isYYB
 * @author marvinqi
 * @createTime 2017/9/20
 */
import getUA from './getUA'

export default function () {
  return /\/qqdownloader\/(\d+)(?:\/(appdetail|external|sdk))?/i.test(getUA())
}


// WEBPACK FOOTER //
// ../src/jsbridge/package/src/libs/os/src/isYYB.js